import React from 'react';
import { ArrowRightIcon, CheckCircle2Icon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  note?: string;
  tone?: 'light' | 'dark';
  className?: string;
};
export function CtaButton({
  label,
  note,
  tone = 'light',
  className = ''
}: CtaButtonProps) {
  return <div className={`flex w-full flex-col items-center ${className}`} data-id="element-108" data-mp="cj7r6j56tbe8">
      <a href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-[18px] text-center text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_12px_30px_-10px_rgba(22,163,74,0.75)] ring-1 ring-inset ring-white/10 transition-[background-color,transform] duration-150 ease-out hover:bg-cta-hover active:scale-[0.97] focus:outline-none focus-visible:ring-4 focus-visible:ring-cta/40 sm:py-5 sm:text-xl" data-id="element-109" data-mp="qjsbxkunxhad">
        <CheckCircle2Icon className="h-6 w-6 shrink-0" aria-hidden="true" data-id="element-110" data-mp="15ahs71mzdml3" />
        <span data-id="element-111" data-mp="35xnycr12xwhs">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-112" data-mp="35yh9e472n85q" />
      </a>
      {note && <p className={`mt-3 max-w-xl text-center text-sm leading-relaxed ${tone === 'dark' ? 'text-brand-100' : 'text-muted'}`} data-id="element-113" data-mp="3ex2r5x4pyj5g">
          {note}
        </p>}
    </div>;
}